import {
  GraphQLNonNull,
  GraphQLList,
  GraphQLID,
  GraphQLObjectType,
  GraphQLString
} from 'graphql'
import { Context } from '../shared'
import { ContrastGraphQLFieldConfig } from '..'
import { ContrastQueryParameters } from '../endpoint-helpers'

interface QueryArgs {
  readonly organizationID: string
  readonly applicationLanguage: string
}

const queryArgs = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  applicationLanguage: {
    description: 'The application language',
    type: new GraphQLNonNull(GraphQLString)
  }
}

interface Rule {
  readonly uuid: string
  readonly displayName: string
}

const protectRuleType = new GraphQLObjectType({
  name: 'ProtectRule',
  fields: () => ({
    uuid: {
      description: 'Rule ID',
      type: new GraphQLNonNull(GraphQLString)
    },
    displayName: {
      description: 'Rule display name',
      type: new GraphQLNonNull(GraphQLString)
    }
  })
})

export const protectRules: ContrastGraphQLFieldConfig<
  any,
  Context,
  QueryArgs,
  Rule[]
> = {
  description: 'Get all protect rules, filtered by application language.',
  type: new GraphQLNonNull(
    new GraphQLList(new GraphQLNonNull(protectRuleType))
  ),
  args: queryArgs,
  async resolve(_source, args, context) {
    const { organizationID, applicationLanguage } = args
    const { connector } = context

    const params = new ContrastQueryParameters()
    params.append('quickFilter', applicationLanguage)

    const { rules = [] } = await connector.get(
      `/${organizationID}/protection/rules?${params}`
    )
    return rules.map(
      ({ displayName, uuid }): Rule => ({
        uuid,
        displayName
      })
    )
  }
}
